const navBar = (function(){

    const getHeader = document.querySelector('.header');
    const getHeaderHamburger = document.querySelector('.header-hamburger');
    const getButtonHamburger = document.querySelector('#hamburger');
    const getButtonHamburgerClose = document.querySelector('#hamburger-close');
    const getAllItemsList = document.querySelectorAll('#header-list .animation-items');
    const getAllItemsListTwo = document.querySelectorAll('#header-list-second .animation-items');
     

    //LOADER
    function _loader(){

        let getLoaderContainer = document.querySelector('.loader-general');

        setTimeout(()=>{
            getLoaderContainer.classList.add('hidden');
        },200);
        
    }


    //BUSCADOR

    function _search(){

        let getSearch = document.querySelector('.search');
        let getOpenSearch = document.querySelector('#open-search');
        let getCloseSearch = document.querySelector('#close-search');

        
        getOpenSearch.addEventListener('click', ()=>{

            getSearch.classList.add('active');

        });

        getCloseSearch.addEventListener('click', ()=>{

            getSearch.classList.remove('active');

        });

    }

    //HAMBURGUESA FUNCIONALIDAD
    function _hamburguer(){

        let getBackgroundHamburger = document.querySelector('.header-hamburger__fondo');

        getButtonHamburger.addEventListener('click', ()=>{

            //Animaciones de boton hamburguesa
            getButtonHamburger.classList.add('open');
            getButtonHamburger.classList.remove('close');

            getButtonHamburgerClose.classList.add('open');
            getButtonHamburgerClose.classList.remove('close');

            getHeader.classList.add('active');

            getHeaderHamburger.classList.add('active');

            setTimeout(()=>{
                getBackgroundHamburger.classList.add('active');
            }, 1000);

            //ITEMS MENU
            getAllItemsList.forEach((data)=>{
                data.classList.add('open');
            });

            getAllItemsListTwo.forEach((data)=>{
                data.classList.add('open');
            });

        });


        getButtonHamburgerClose.addEventListener('click', ()=>{

            //Animaciones de boton hamburguesa
            getButtonHamburgerClose.classList.remove('open');
            getButtonHamburgerClose.classList.add('close');

            setTimeout(()=>{
                getButtonHamburger.classList.remove('open');
                getButtonHamburger.classList.add('close');
            }, 500);

            getHeader.classList.remove('active');

            getHeaderHamburger.classList.remove('active');

            getBackgroundHamburger.classList.remove('active');


            //ITEMS MENU
            getAllItemsList.forEach((data)=>{
                data.classList.remove('open');
            });

            getAllItemsListTwo.forEach((data)=>{
                data.classList.remove('open');
            });


        });

    }

    //TEXTO DINAMICO
    function _breadcrumb(){
        function changeTextInmobile(){
            let getTextDinamic = document.querySelector('.team-top-breadcrumb__link');
            getTextDinamic.textContent = "...";
        }
    
    
        if(window.screen.width < 769){
            changeTextInmobile();
        }
    }

    function _scrollDown(){
        const getBtnScrollDown = document.querySelector('.scroll-down');

        getBtnScrollDown && getBtnScrollDown.addEventListener('click',()=>{
            window.scroll(window.scrollY, screen.height - 155);
        });

        getBtnScrollDown && window.addEventListener('scroll', ()=>{
            window.scrollY > 50 ? getBtnScrollDown.classList.add('disable') : getBtnScrollDown.classList.remove('disable');
        });

        getBtnScrollDown && window.scrollY > 50 ? getBtnScrollDown.classList.add('disable'): console.log(window.scrollY);
    }


    return {
        setHandleEvent : function(){
            try{
            _hamburguer()
            }catch(error){ }
            try{
            _loader()
            }catch(error){ }
            try{
                _search()
            }catch(error){ }
            try{
                _breadcrumb()
            }catch (error){ }
            try{
                _scrollDown()
            }catch (error){ }
        }
    }

})();


const loadNavBarHandlers = ()=>{
        navBar.setHandleEvent()
}

export {
    loadNavBarHandlers
}